import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";
import { trackEvent } from "../lib/analytics";

/*
  Share VeriHandi via native Web Share API where available; otherwise copies
  the current URL to the clipboard. Works on iOS Safari, Android Chrome,
  desktop Chromium. Silent failure mode is "copy to clipboard".
*/
export default function ShareButton({ className = "" }) {
  const [justCopied, setJustCopied] = useState(false);

  async function share() {
    const url = window.location.origin + "/";
    const title = "VeriHandi — very handy tools for everyday tasks";
    const text = "A quiet set of tools for the small, stubborn tasks of daily life.";
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
        trackEvent("share_click", { method: "web_share_api", path: window.location.pathname });
        return;
      }
    } catch {
      // user cancelled — do nothing
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setJustCopied(true);
      trackEvent("share_click", { method: "clipboard", path: window.location.pathname });
      toast.success("Link copied — paste it anywhere");
      setTimeout(() => setJustCopied(false), 1500);
    } catch {
      toast.error("Could not copy link");
    }
  }

  return (
    <button
      onClick={share}
      data-testid="share-button"
      className={`h-9 w-9 rounded-lg flex items-center justify-center hover:bg-[color:var(--surface-2)] transition-colors ${className}`}
      aria-label="Share VeriHandi"
      title="Share VeriHandi"
    >
      {justCopied ? <Check className="h-[18px] w-[18px] text-[color:var(--primary-ink)]" /> : <Share2 className="h-[18px] w-[18px]" />}
    </button>
  );
}
